interface ArrowRightIconProps {
	iconColor?: string;
	width?: string;
	height?: string;
}
const ArrowRightIcon = ({ iconColor = '#868E96', width = '8', height = '14' }: ArrowRightIconProps) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 7 12" fill="none">
		<path d="M6.25 11.25L1.84853 6.84853C1.3799 6.3799 1.3799 5.6201 1.84853 5.15147L6.25 0.75" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export default ArrowRightIcon;
